import './flyout-menu.css'
import LogoSvg from '../../../../assets/features/workplace/images/logo-suus-beverages.svg?react';
import {useAuth} from "@/app/identity-access-management/authentication/context/AuthContext.tsx";

interface MenuProps {
    closeMenu: () => void;
}

function  FlyoutMenu({closeMenu}: MenuProps) {
    const { state, logout } = useAuth();

    return (
        <div id="myNav" className="navigation">
            <div className="header--flyout">
                <a onClick={() => closeMenu()} className="button-close" >&times;</a>
                <LogoSvg className="logo" />
            </div>

            <div className="menu">
                <ul className="menu-main">
                    <li><a onClick={closeMenu} href={`/home`} className="menuItem">Home</a></li>
                    <li><a onClick={closeMenu} href={`/shop`} className="menuItem">Shop</a></li>
                    <li><a onClick={closeMenu} href={`/company`} className="menuItem">Company</a></li>
                    <li><a onClick={closeMenu} href={`/stories`} className="menuItem">Stories</a></li>
                </ul>

                <ul className="menu-user">
                    {state.status === "authenticated" && <li><a onClick={closeMenu} href={`/auth/user-profile`} className="menuItem">Mein Profil</a></li>}
                    {state.status === "authenticated" && <li><a onClick={closeMenu} href={`/settings`} className="menuItem">Einstellungen</a></li>}
                    {state.status === "authenticated" && <li><a onClick={closeMenu} href={`/customer/orders`} className="menuItem">Bestellungen</a></li>}
                    <br/>
                    {state.status === "anonymous" && <li><a onClick={closeMenu} href={`/auth/user-login`} className="menuItem">Anmelden</a></li>}
                    {state.status === "authenticated" && <li><a onClick={() => { logout(); closeMenu(); }} href="#" className="menuItem">Abmelden</a></li>}
                </ul>
            </div>
        </div>
    )
}

export default FlyoutMenu
